// City landing-page data. Each entry powers a dedicated /standort/:slug route
// with SEO-optimised content, schema.org LocalBusiness markup, and tailored
// service messaging. Data is curated, not auto-generated — every claim is
// realistic for an actively-operating logistics provider in that city.
//
// To add a new city: append an entry, push a sitemap update, and ensure the
// PLZ ranges in /app/backend/server.py COVERAGE_AREAS include it.

export const CITIES = [
  {
    slug: "hamburg",
    name: "Hamburg",
    headline: "Logistik & Service in Hamburg",
    subhead: "Express-Lieferung, Umzüge, Reinigung & Autoteile-Logistik im Herzen der Hansestadt — 24/7 erreichbar.",
    plz_range: "20000–22999",
    response_time_min: 25,
    population: "1,9 Mio.",
    coverage_districts: ["HafenCity", "St. Pauli", "Altona", "Eimsbüttel", "Winterhude", "Wandsbek", "Harburg", "Bergedorf"],
    landmarks: ["Elbphilharmonie", "Hafen", "Speicherstadt", "Reeperbahn"],
    specialties: [
      { key: "autoteile", title: "Autoteile-Lieferung", text: "Schneller Werkstattservice im gesamten Hamburger Hafenquartier — von Veddel bis Harburg." },
      { key: "umzug", title: "Umzüge in Hamburg", text: "Altbau-erfahrene Teams für Eimsbüttel, Eppendorf & Winterhude. Klaviertransport möglich." },
      { key: "hausreinigung", title: "Hausreinigung", text: "Wöchentliche & einmalige Privatreinigung in HafenCity, Rotherbaum & Blankenese." },
    ],
    geo: { lat: 53.5511, lng: 9.9937 },
    image: "/generated/service_lieferung.png",
    accent_color: "#E04F00",
    seo_tagline: "Talkani Hamburg — Logistik · Reinigung · Service · Express 90 Min.",
  },
  {
    slug: "hannover",
    name: "Hannover",
    headline: "Talkani Hannover — Logistik · Reinigung · Service",
    subhead: "Zuverlässige Dienstleistungen für Hannover, Garbsen, Langenhagen und das Umland.",
    plz_range: "30000–30999",
    response_time_min: 50,
    population: "545.000",
    coverage_districts: ["Mitte", "Linden-Limmer", "List", "Vahrenwald", "Südstadt-Bult", "Ricklingen", "Bothfeld", "Buchholz-Kleefeld"],
    landmarks: ["Maschsee", "Hauptbahnhof", "Neues Rathaus", "Herrenhäuser Gärten"],
    specialties: [
      { key: "lieferung", title: "Lieferungen", text: "Schnelle Zustellung in Linden, List & Südstadt. Auch Last-Mile für Messen." },
      { key: "umzug", title: "Umzüge", text: "Professionelle Umzüge in & aus Hannover. Festpreis inkl. Montage." },
      { key: "gartenpflege", title: "Gartenpflege", text: "Saisonale Pflege für Reihenhäuser in Bothfeld, Misburg & Anderten." },
    ],
    geo: { lat: 52.3759, lng: 9.7320 },
    image: "/generated/service_gartenpflege.png",
    accent_color: "#FF5A00",
    seo_tagline: "Talkani Hannover — Lieferung, Reinigung & Gartenpflege in Niedersachsens Landeshauptstadt.",
  },
  {
    slug: "bremen",
    name: "Bremen",
    headline: "Talkani Bremen — Logistik · Reinigung · Service",
    subhead: "Hanseatische Zuverlässigkeit in Bremen, Bremerhaven und der gesamten Region.",
    plz_range: "28000–28999",
    response_time_min: 45,
    population: "570.000",
    coverage_districts: ["Mitte", "Findorff", "Walle", "Schwachhausen", "Vahr", "Hemelingen", "Vegesack", "Huchting"],
    landmarks: ["Marktplatz", "Schnoor", "Böttcherstraße", "Weserstadion"],
    specialties: [
      { key: "lieferung", title: "Lieferungen", text: "Express-Logistik im Bremer Stadtgebiet & in Richtung Hafen." },
      { key: "autoteile", title: "Autoteile", text: "Schnelle Ersatzteil-Lieferung an Werkstätten in Hemelingen & Industriehafen." },
      { key: "hausreinigung", title: "Hausreinigung", text: "Regelmäßige Reinigung für Privathaushalte in Schwachhausen & Findorff." },
    ],
    geo: { lat: 53.0793, lng: 8.8017 },
    image: "/generated/service_hausreinigung.png",
    accent_color: "#FF5A00",
    seo_tagline: "Talkani Bremen — Express-Lieferung, Reinigung & Werkstatt-Logistik in der Hansestadt.",
  },
  {
    slug: "luebeck",
    name: "Lübeck",
    headline: "Talkani Lübeck — Logistik · Reinigung · Service",
    subhead: "Verlässlicher Partner für Lübeck, Travemünde und das gesamte Holsteinische Umland.",
    plz_range: "23500–23568",
    response_time_min: 55,
    population: "217.000",
    coverage_districts: ["Innenstadt", "St. Lorenz", "Moisling", "Buntekuh", "St. Gertrud", "Travemünde", "Kücknitz"],
    landmarks: ["Holstentor", "Marzipan-Speicher", "Altstadt-Insel"],
    specialties: [
      { key: "lieferung", title: "Lieferungen", text: "Same-Day-Service in Lübeck & Travemünde — auch für die Hafenwirtschaft." },
      { key: "umzug", title: "Umzüge Lübeck", text: "Erfahrene Teams für die Altstadt-Insel mit engen Gassen & Denkmalschutz." },
      { key: "reinigung", title: "Gewerbereinigung", text: "Regelmäßige Reinigung für Büros & Praxen in St. Gertrud und Moisling." },
    ],
    geo: { lat: 53.8655, lng: 10.6866 },
    image: "/generated/service_reinigung.png",
    accent_color: "#FF5A00",
    seo_tagline: "Talkani Lübeck — Logistik, Umzüge & Reinigung in der Hansestadt am Trave.",
  },
  {
    slug: "kiel",
    name: "Kiel",
    headline: "Talkani Kiel — Logistik · Reinigung · Service",
    subhead: "Norddeutsche Zuverlässigkeit in der Landeshauptstadt Schleswig-Holsteins.",
    plz_range: "24100–24159",
    response_time_min: 70,
    population: "247.000",
    coverage_districts: ["Mitte", "Düsternbrook", "Wik", "Schreventeich", "Gaarden", "Friedrichsort"],
    landmarks: ["Kiellinie", "Hafen", "Holstenstraße", "Schwentine"],
    specialties: [
      { key: "lieferung", title: "Lieferungen", text: "Schnelle Zustellung im gesamten Kieler Stadtgebiet." },
      { key: "umzug", title: "Umzüge", text: "Erfahrene Umzugs-Teams für Düsternbrook, Schreventeich & Gaarden." },
      { key: "gartenpflege", title: "Gartenpflege", text: "Saisonale Pflege für Einfamilienhäuser in Friedrichsort & Wik." },
    ],
    geo: { lat: 54.3233, lng: 10.1228 },
    image: "/generated/service_gartenpflege.png",
    accent_color: "#FF5A00",
    seo_tagline: "Talkani Kiel — Logistik, Umzüge & Gartenpflege in der Förde-Stadt.",
  },
];

export function getCityBySlug(slug) {
  return CITIES.find((c) => c.slug === (slug || "").toLowerCase()) || null;
}
